// extracted by mini-css-extract-plugin
export var colorSquare = "_p6-0";
export var danger = "_p6-5";
export var lightPink = "_p6-8";
export var neutralBlue = "_p6-7";
export var neutralYellow = "_p6-6";
export var normal = "_p6-1";
export var primary = "_p6-2";
export var primaryLight = "_p6-3";
export var solidBlack = "_p6-g";
export var solidGreen = "_p6-b";
export var solidLightBlue = "_p6-d";
export var solidNavy = "_p6-c";
export var solidOrange = "_p6-f";
export var solidPink = "_p6-e";
export var solidRed = "_p6-9";
export var solidYellow = "_p6-a";
export var success = "_p6-4";